import React from 'react';
import PropTypes from 'prop-types';

import useLanguage from '../../../../hooks/useLanguage';
import Star from '../../../../svg/star_item.svg';

const HomeAdvantages = ({ advantagesData }) => {
  const langToggle = useLanguage;

  return (
    <section className="home-advantages" data-scroll-section>
      <div className="content-wrapper">
        <div className="home-advantages__items">
          {advantagesData.map((item, index) => {
            return (
              <div className="home-advantages__item" key={index}>
                <div className="home-advantages__item-wrapper">
                  <Star className="home-advantages__item-star" />
                  <h2 className="home-advantages__item-title">
                    {langToggle(item.title_ua, item.title_ru)}
                  </h2>
                  <p className="home-advantages__item-description">
                    {langToggle(item.description_ua, item.description_ru)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

HomeAdvantages.propTypes = {
  advantagesData: PropTypes.array,
};

export default HomeAdvantages;
